/* eslint-disable @typescript-eslint/naming-convention */
// Full state list can be found at https://developer.paypal.com/braintree/docs/guides/3d-secure/server-side/node
export const THREED_SECURE_ERRORS: Record<string, string> = {
  authenticate_error:
    'An error occurred within the 3D Secure authentication system. Please try again or contact support if the error persists.',
  authenticate_failed: '3D Secure authenticate failed. Please try again.',
  authenticate_failed_acs_error: '3D Secure authentication failed. Please try again or contact support.',
  authenticate_frictionless_failed: '3D Secure authentication failed. Please try another card or contact support.',
  authenticate_rejected: '3D Secure authentication rejected. Please try another card or contact support.',
  authenticate_signature_verification_failed: '3D Secure signature verification failed. Please try again.',
  authenticate_unable_to_authenticate: '3D Secure authentication was unsuccessful. Please try again.',
  authentication_unavailable:
    'The card network is unavailable to verify the card using 3D Secure. Please try another card or contact support.',
  challenge_required: '3D Secure authentication challenge required. Please try another card or contact support.',
  lookup_enrolled: '3D Secure authentication was cancelled. Please try again.',
  lookup_error: '3D Secure authentication failed. Please try again.',
  lookup_failed_acs_error: '3D Secure lookup failed. Please try again or contact support.',
  lookup_not_enrolled: '3D Secure authentication enrollment failed. Please try again.',
  unsupported_account_type: 'The card network does not support this card. Please try another card or contact support.',
  unsupported_card: 'The provided card is not supported. Please try another card or contact support.',
  unsupported_three_d_secure_version:
    '3D Secure verification failed due to unsupported version. Please contact support.',
};
